var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"desc"},[_c('img',{attrs:{"src":require("../assets/404.png")}}),_vm._v("你访问的页面丢失，请联系管理员！")])])}]

export { render, staticRenderFns }